import { FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

import { CHECKBOX_LABEL } from "ui/checkbox/checkbox.constants";
import { type CheckboxSize } from "ui/checkbox/checkbox.types";

export const CheckboxLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checkboxSize",
})<{ checkboxSize: CheckboxSize }>(({ theme, checkboxSize }) => ({
  marginLeft: 0,
  marginRight: 0,
  gap: theme.spacing(CHECKBOX_LABEL[checkboxSize].gap),

  "& .MuiFormControlLabel-label": {
    ...theme.typography[CHECKBOX_LABEL[checkboxSize].variant],
    fontWeight: theme.typography.fontWeightRegular,

    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
    },
  },
}));
